<template>
    <div class="card is-shadowless">
        <div class="card-header is-shadowless">
            <h3 class="card-header-title">
                Los mejores Jugadores
            </h3>
            <p v-show="false">Character ranking, el ranking de personajes o jugadores (players)</p>
        </div>
        <div class="card-content is-paddingless">
            <table class="table is-hoverable is-fullwidth" v-if="rankingItems.length > 0">
                <thead>
                    <tr class="has-text-justified">
                    <th>Pos.</th>
                    <th>Nombre</th>
                    <th><abbr title="Grand Resets">G.</abbr>|<abbr title="Resets">R.</abbr></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rank, n) in rankingItems" :key="n" 
                    :class="{'has-text-justified':true, 'vip-back has-background-link-light':rank.isvip>0}">
                    <td>
                        <fa icon="medal" :class="{'gold-color':n==0,'silver-color':n==1,'bronze-color':n==2}" />
                    </td>
                    <td>
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="rank.is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else /> {{rank.name}} 
                        <fa v-if="rank.isvip>0" icon="award" class="has-text-link" v-tooltip="{ content: 'VIP' }" />
                    </td>
                    <td>{{rank.grandresets}}|{{rank.resets}}</td>
                    </tr>
                </tbody>
            </table>
            <p v-else>Próximamente...</p>
        </div>
        <div class="card-footer" v-if="rankingItems.length > 0">
            <router-link to="/ranking/jugadores" class="card-footer-item has-text-link">Ver más</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name:'HomeRankingPlayerSection',
    computed: {
        api() {
            return this.$store.getters.GetApiPath
        },
        rankingItems() {
            return this.$store.getters.GetTop3Player
        }
    }
}
</script>

<style>

</style>